import * as nativeComponentAPI from '../../../../api/nativeComponentAPI'
import * as nativeComponentListener from '../../../../api/nativeComponentListener'
import VisibleComponent from "./VisibleComponent";
import NativeComponent from "../NativeComponent";

const {nativeComponentAbility , keyValueFilter, responseFilter} = NativeComponent

//播放状态枚举
const PLAYER_STATE = {
    PLAYERING: Symbol('PLAYERING'),
    STOPPED: Symbol('STOPPED'),
    PAUSED: Symbol('PAUSED'),
}
//静音状态枚举
const VOLUME_STATE = {
    MUTE: Symbol('MUTE'),
    UNMUTE: Symbol('UNMUTE'),
}

const [
    _playerState,
    _volumeState
] = [
    Symbol('_playerState'),
    Symbol('_volumeState')
]

let isMute = 1

/**
 * @constructor
 * @extends VisibleComponent
 * @param options {Object} 构造参数对象
 * @param options.campaign {Object} campaign对象
 * @param options.unitId {Number} 广告位id
 * @param options.mute {Boolean} 是否初始静音
 * @param options.showTime {Boolean} 是否显示倒计时
 * @param options.showMute {Boolean} 是否显示静音按钮
 * @param options.showClose {Boolean} 是否显示关闭按钮
 */
class PlayerView extends VisibleComponent {
    constructor (options={}) {
        const action = nativeComponentAPI.createPlayerView
        const {campaign, unitId, mute=true, showTime=false, showMute=false, showClose=false} = options
        const createParams = {
            campaign,
            unitId,
            mute: mute ? 1: 0,
            show_time: showTime ? 1: 0,
            show_mute: showMute ? 1: 0,
            show_close: showClose ? 1: 0,
        }
        super(action, {
            ...options,
            params: createParams
        })

        this[_volumeState] = VOLUME_STATE.MUTE
        this[_playerState] = PLAYER_STATE.STOPPED

        this[_volumeState] = mute ? VOLUME_STATE.MUTE : VOLUME_STATE.UNMUTE

        console.log('初始化 playView 是否静音：', this[_volumeState] === VOLUME_STATE.MUTE ,options, createParams)

        this.bindPlayerViewEvent()
    }

    // [_volumeState] = VOLUME_STATE.MUTE
    //
    // [_playerState] = PLAYER_STATE.STOPPED


    bindPlayerViewEvent() {

        this.onPlay((data)=>{
            console.log(`PlayerView id:${this.getId()} onPlay`, data)
            this[_playerState] = PLAYER_STATE.PLAYERING
        })
        this.onPause((data)=>{
            console.log(`PlayerView id:${this.getId()} onPause`, data)
            this[_playerState] = PLAYER_STATE.PAUSED
        })
        this.onResume((data)=>{
            console.log(`PlayerView id:${this.getId()} onResume`, data)
            this[_playerState] = PLAYER_STATE.PLAYERING
        })
        this.onStop((data)=>{
            console.log(`PlayerView id:${this.getId()} onStop`, data)
            this[_playerState] = PLAYER_STATE.STOPPED
        })


        this.onMute((data)=>{
            console.log(`PlayerView id:${this.getId()} onMute`, data)
            this[_volumeState] = VOLUME_STATE.MUTE
        })
        this.onUnmute((data)=>{
            console.log(`PlayerView id:${this.getId()} onUnmute`, data)
            this[_volumeState] = VOLUME_STATE.UNMUTE
        })


        this.onFinish((data)=>{
            console.log(`PlayerView id:${this.getId()} onFinish`, data)
            this[_playerState] = PLAYER_STATE.STOPPED
        })
        this.onFailed((data)=>{
            console.log(`PlayerView id:${this.getId()} onFailed`, data)
            this[_playerState] = PLAYER_STATE.STOPPED
        })
        this.onLoadTimeout((data)=>{
            console.log(`PlayerView id:${this.getId()} onLoadTimeout`, data)
        })
        this.onCloseBtnClicked((data)=>{
            console.log(`PlayerView id:${this.getId()} onCloseBtnClicked`, data)
        })
        this.onMuteBtnClicked((data)=>{
            console.log(`PlayerView id:${this.getId()} onMuteBtnClicked `, data, data.mute, this.isMute())
            //同步静音状态
            /*if(data.mute === this.isMute()){
                this[_volumeState] = VOLUME_STATE.MUTE
            }else{
                this[_volumeState] = VOLUME_STATE.UNMUTE
            }*/
            this[_volumeState] = data.mute? VOLUME_STATE.MUTE :VOLUME_STATE.UNMUTE

            this.toggleMute().then(()=>{
                console.log(`PlayerView id:${this.getId()} toggleMute. mute:`, this.isMute())
            })

        })
        this.onClicked(event => {
            console.log(`PlayerView id:${this.getId()} onClicked ++`, event)
        })
    }

    /**
     * 播放
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    @responseFilter(function(res){
        this[_playerState] = PLAYER_STATE.PLAYERING
        return res
    })
    play(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.nativeVideoPlay(_params)
    }


    /**
     * 暂停
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    @keyValueFilter({ key: _playerState, value: PLAYER_STATE.PAUSED })
    pause(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.nativeVideoPause(_params)
    }

    /**
     * 恢复播放
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    @keyValueFilter({ key: _playerState, value: PLAYER_STATE.PLAYERING })
    resume(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.nativeVideoPause(_params)
    }

    /**
     * 停止
     * @param params
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    @responseFilter(function(res){
        this[_playerState] = PLAYER_STATE.STOPPED
        return res
    })
    stop(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.nativeVideoStop(_params)
    }

    /**
     * 设置为静音
     * @param params
     * @returns {*|Promise<any>}
     */
    @keyValueFilter({ key: _volumeState, value: VOLUME_STATE.MUTE })
    @nativeComponentAbility
    mute(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.nativeVideoMute(_params)
    }

    /**
     * 设置为非静音
     * @param params
     * @returns {*|Promise<any>}
     */
    @keyValueFilter({ key: _volumeState, value: VOLUME_STATE.UNMUTE })
    @nativeComponentAbility
    unmute(params) {
        const _params = this.getInvokeParams(params)
        return nativeComponentAPI.nativeVideoUnmute(_params)
    }

    /**
     * 切换静音状态
     * @returns {*|Promise<any>}
     */
    toggleMute(){
        let ret
        if(this[_volumeState] === VOLUME_STATE.MUTE) {
            console.log('调用关闭静音 ')
            ret = this.unmute()
        }else{
            console.log('调用打开静音 ')
            ret = this.mute()
        }
        ret.then(()=>{
            setTimeout(()=>{
                console.log('当前mute状态 mute：',this[_volumeState] === VOLUME_STATE.MUTE)
            },1e3)
        })
        return ret
    }

    /**
     * 切换播放状态
     * @returns {*|Promise<any>}
     */
    togglePlay(){
        let ret
        if(this[_playerState] === PLAYER_STATE.PLAYERING) {
            ret = this.pause()
        }else{
            ret = this.play()
        }
        return ret
    }

    /**
     * 是否正在播放
     * @returns {boolean}
     */
    isPlaying(){
        return this[_playerState] === PLAYER_STATE.PLAYERING
    }
    /**
     * 是否暂停
     * @returns {boolean}
     */
    isPaused(){
        return this[_playerState] === PLAYER_STATE.PAUSED
    }
    /**
     * 视频是否停止
     * @returns {boolean}
     */
    isStopped(){
        return this[_playerState] === PLAYER_STATE.STOPPED
    }


    /**
     * 是否静音
     * @returns {boolean}
     */
    isMute(){
        return this[_volumeState] === VOLUME_STATE.MUTE
    }
    /**
     * 是否非静音
     * @returns {boolean}
     */
    isUnmute(){
        return this[_volumeState] === VOLUME_STATE.UNMUTE
    }



    //*****************************************--事件--******************************************//

    /**
     * 播放时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onPlay(cb) {

        'function' === typeof cb &&
        nativeComponentListener.onPlayerPlay(this.getId(), cb)
    }

    /**
     * 暂停时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onPause(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerPause(this.getId(), cb)
    }

    /**
     * 恢复播放时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onResume(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerResume(this.getId(), cb)
    }

    /**
     * 停止时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onStop(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerStop(this.getId(), cb)
    }

    /**
     * 静音时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onMute(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerMute(this.getId(), cb)
    }

    /**
     * 取消静音时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onUnmute(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onUnmute(this.getId(), cb)
    }

    /**
     * 播放完成时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onFinish(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerFinish(this.getId(), cb)
    }

    /**
     * native播放失败时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onFailed(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerFailed(this.getId(), cb)
    }

    /**
     * 缓冲超时时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onLoadTimeout(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerTimeout(this.getId(), cb)
    }

    /**
     * player上的关闭按钮被点击时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onCloseBtnClicked(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerCloseBtnClicked(this.getId(), cb)
    }

    /**
     * player上的音量按钮被点击时触发
     * @param cb | Function
     * @returns {*|Promise<any>}
     */
    @nativeComponentAbility
    onMuteBtnClicked(cb) {
        'function' === typeof cb &&
        nativeComponentListener.onPlayerMuteBtnClicked(this.getId(), data=>{
            //console.log('mute当前值1',isMute)
            //isMute = !isMute
            //console.log('mute当前值2',isMute)
            console.log('onPlayerMuteBtnClicked ========> ',data.mute)
            const { mute } = data
            cb({
                mute: (mute===1 || mute===true)?true: false
                //mute:isMute
            })
        })
    }
}

export default PlayerView